import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Big from 'big.js';
import { formatTradeDate, formatCreatedAt } from 'helpers/dates';
import { formatAmount } from '../formatAmount';
import TradeItem from '../TradeItem';
import styles from './styles.module.scss';
import sharedStyles from '../styles.module.scss';

Big.RM = 0;

function Trade({ item, market }) {
  const isBuy = item.makerOrder.side === 'SELL';

  const price = formatAmount(item.price, market.minTick, market.minTickLength);
  const quantity = formatAmount(item.quantity, market.minQty, market.minQtyLength);

  const tradeDate = formatTradeDate(item.createdAt);
  const tradeCreatedAt = formatCreatedAt(item.createdAt);

  return (
    <tr
      className={classnames([sharedStyles.tableRow, styles.historyRow], {
        [styles.historySell]: !isBuy,
        [styles.historyBuy]: isBuy
      })}
      title={tradeCreatedAt}>
      <td className={styles.triangleCell}>
        {isBuy ? <div className={styles.triangleUp} /> : <div className={styles.triangleDown} />}
      </td>
      <td className={sharedStyles.tableCell}>
        <TradeItem title={item.price} isUp={isBuy} rightAligned>
          {price}
        </TradeItem>
      </td>
      <td className={sharedStyles.tableCell}>
        <TradeItem rightAligned title={item.quantity}>
          {quantity}
        </TradeItem>
      </td>
      <td className={sharedStyles.tableCell}>
        <TradeItem muted rightAligned>
          {tradeDate}
        </TradeItem>
      </td>
    </tr>
  );
}

Trade.propTypes = {
  item: PropTypes.object.isRequired,
  market: PropTypes.object
};

Trade.defaultProps = {
  market: null
};

const propCompare = (prevProps, nextProps) => {
  return (
    prevProps.price === nextProps.price &&
    prevProps.quantity === nextProps.quantity &&
    prevProps.createdAt === nextProps.createdAt &&
    prevProps.market?.name === nextProps.market?.name
  );
};

export default memo(Trade, propCompare);
